<template lang="pug">
.cards-module(v-if="(data&&data.length>0)||loading")
  template(v-if="loading")
    .shadow.card-item
    .shadow.card-item
    .shadow.card-item
  template(v-else)
    template(v-for="item in showCards")
      CardB.card-item(:info="item", @click="clickCard(item)")
    .bottom(v-if="data.length > 3 && !more", @click="showMore") 查看更多
  ConfirmB(
    v-if="confirmVisible",
    left-btn="暂不购买",
    right-btn="继续购买",
    :info="card",
    @onLeft="onConfirmLeft('0')",
    @onRight="onConfirmRight",
    @close="onConfirmLeft"
  )
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { CardService } from '@/service/card';
import CardB from './card-b';
import ConfirmB from './confirm-b'; // 弹出层
import config from '../../../const/config';

export default {
  components: {
    CardB,
    ConfirmB,
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      more: false,
      confirmVisible: false,
      card: null, // 当前卡
    };
  },
  computed: {
    showCards() {
      if (!this.data || this.data.length === 0) {
        return [];
      }
      if (this.data.length <= 3) {
        return this.data;
      }
      if (this.more) {
        return this.data;
      }
      return this.data.slice(0, 3);
    },
  },
  watch: {
    confirmVisible(v) {
      if (v && this.card) {
        UBT.moduleExpose({
          pageId: 'APP_exclusive',
          categoryId: 'platform',
          moduleId: 'APPcard_pop',
          contentId: 'APPcard_pop',
          exposureTimes: 1,
          businessInfo: {
            card_name: this.card.title,
            business: this.card.businessType,
          },
        });
      }
    },
  },
  mounted() { },
  methods: {
    showMore() {
      this.more = true;
    },
    clickCard(item) {
      UBT.clickButton({
        pageId: 'APP_exclusive',
        buttonName: 'APP_bikecard',
        categoryId: 'platform',
        businessInfo: {
          card_time: item.days,
          card_name: item.title,
          business: item.businessType,
        },
      });
      this.card = item;
      this.confirmVisible = true;
    },
    onConfirmLeft() {
      this.confirmVisible = false;
    },
    goSuccess() {
      this.$router.push({
        path: '/card-for-app-success',
        query: { title: 'APP专享卡购买成功' },
      });
    },
    onConfirmRight() {
      this.confirmVisible = false;
      if (this.card) {
        UBT.clickButton({
          pageId: 'APP_exclusive',
          buttonName: 'pop_ook',
          categoryId: 'platform',
          businessInfo: {
            card_name: this.card.title,
            business: this.card.businessType,
          },
        });

        CardService.buy(this.card.detail, Object.assign(this.card.params || {}, {
          returnUrl: `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/pr_index_card-for-app.html#/card-for-app-success`,
        }))
          .then(() => { this.goSuccess(); });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cards-module {
  padding: 0.16rem 0.12rem 0.16rem;

  .card-item {
    &:not(:last-of-type) {
      margin-bottom: 0.08rem;
    }
  }

  .shadow {
    width: 3.27rem;
    height: 0.97rem;
    background: #f7f9fa;
    border-radius: 0.08rem;
  }

  .bottom {
    width: 0.6rem;
    text-align: center;
    margin: 0.16rem auto 0;
    font-size: 0.12rem;
    font-weight: 400;
    color: #5a6066;
    line-height: 0.17rem;
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 45%;
      right: -0.05rem;
      width: 0.08rem;
      height: 0.08rem;
      border-bottom: 0.02rem solid #5a6066;
      border-right: 0.02rem solid #5a6066;
      transform: translateY(-50%) rotate(45deg) scale(0.7);
    }
  }
}
</style>
